// extracted by mini-css-extract-plugin
export default {"staffDepartmentListConfig":"DepartmentListConfig_staffDepartmentListConfig__IDDER","selectDepartmentList":"DepartmentListConfig_selectDepartmentList__+DKHg"};